
import React, { useState } from 'react';
import { EditIcon, DeleteIcon, AddIcon } from './icons';

interface CategoryViewProps {
    categories: string[];
    setCategories: (categories: string[]) => void;
}

const CategoryView: React.FC<CategoryViewProps> = ({ categories, setCategories }) => {
    const [newCategory, setNewCategory] = useState('');
    const [editingCategory, setEditingCategory] = useState<{ original: string; current: string } | null>(null);

    const handleAddCategory = () => {
        if (newCategory && !categories.includes(newCategory)) {
            setCategories([...categories, newCategory].sort());
            setNewCategory('');
        }
    };
    
    const handleDeleteCategory = (categoryToDelete: string) => {
        if (window.confirm(`¿Estás seguro de que quieres eliminar la categoría "${categoryToDelete}"?`)) {
            setCategories(categories.filter(c => c !== categoryToDelete));
        }
    };

    const handleEditCategory = (category: string) => {
        setEditingCategory({ original: category, current: category });
    };

    const handleUpdateCategory = () => {
        if (editingCategory) {
            // Check if new name exists (and it's not the original name)
            if (categories.includes(editingCategory.current) && editingCategory.current !== editingCategory.original) {
                alert("Ya existe una categoría con ese nombre.");
                return;
            }
            if(editingCategory.current.trim() === '') {
                 alert("El nombre de la categoría no puede estar vacío.");
                return;
            }
            setCategories(categories.map(c => c === editingCategory.original ? editingCategory.current : c).sort());
            setEditingCategory(null);
        }
    };

    return (
         <div className="bg-light-surface dark:bg-surface p-6 rounded-lg border border-light-border dark:border-border shadow-md">
            <h3 className="font-bold text-lg text-light-text-primary dark:text-text-primary mb-2">Gestión de Categorías</h3>
            <p className="text-sm text-light-text-secondary dark:text-text-secondary mb-6">Añade, edita o elimina las categorías para organizar tus finanzas.</p>
            <div className="max-w-2xl mx-auto">
                <div className="flex gap-2 mb-6">
                    <input 
                        type="text"
                        value={newCategory}
                        onChange={(e) => setNewCategory(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleAddCategory()}
                        placeholder="Nombre de la nueva categoría"
                        className="flex-grow bg-light-background dark:bg-background border border-light-border dark:border-border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
                    />
                    <button onClick={handleAddCategory} className="flex-shrink-0 flex items-center px-4 py-2 bg-primary text-white rounded-lg hover:bg-blue-600 transition-colors duration-200 text-sm font-medium shadow-sm">
                       <AddIcon className="w-5 h-5 mr-2" /> Añadir
                    </button>
                </div>
                <div className="space-y-3">
                    {categories.map(category => (
                        <div key={category} className="bg-gray-100 dark:bg-gray-800 p-3 rounded-lg flex justify-between items-center group">
                            {editingCategory?.original === category ? (
                                 <input 
                                    type="text"
                                    value={editingCategory.current}
                                    onChange={(e) => setEditingCategory({...editingCategory, current: e.target.value})}
                                    onBlur={handleUpdateCategory}
                                    onKeyDown={(e) => e.key === 'Enter' && handleUpdateCategory()}
                                    autoFocus
                                    className="bg-light-background dark:bg-background border border-light-border dark:border-border rounded-md px-3 py-1 text-light-text-primary dark:text-text-primary focus:outline-none focus:ring-2 focus:ring-primary"
                                />
                            ) : (
                                 <span className="text-light-text-primary dark:text-text-primary">{category}</span>
                            )}
                           
                            <div className="flex">
                               <button onClick={() => handleEditCategory(category)} className="p-2 text-light-text-secondary dark:text-text-secondary hover:text-primary"><EditIcon className="w-5 h-5"/></button>
                               <button onClick={() => handleDeleteCategory(category)} className="p-2 text-light-text-secondary dark:text-text-secondary hover:text-red-500"><DeleteIcon className="w-5 h-5"/></button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default CategoryView;
